import containsLowercaseCharacters from '@/_helpers/contains_lowercase_characters';
import containsNumbers from '@/_helpers/contains_numbers';
import containsUppercaseCharacters from '@/_helpers/contains_uppercase_characters';
import minTenCharacters from '@/_helpers/min_10_characters';
import twoSpecialSymbols from '@/_helpers/contains_special_symbols';

export default (value: string): boolean =>
	containsNumbers(value) && containsUppercaseCharacters(value) && containsLowercaseCharacters(value) && minTenCharacters(value) && twoSpecialSymbols(value);
